module.exports = __webpack_public_path__ + "8e8ad26ed516a9c363eaa197bd0584f2.MP3";